import React from "react";
import {  useNavigate } from 'react-router-dom';
import logo from "./images/logo_ticket_buydeal.jpg";
import event_img from "./images/event_main.jpg";
import "./css/homepage_orginfo.css";




const HomePageOrgInfo = () =>  {
	const navigate = useNavigate();
	
  return (
    <div className="eo-container">
	
	{/* NAVBAR */}
	<header className="navbar">
	  <div className="navbar-inner">
	    <div className="logo" onClick={() => navigate("/")}>
	    <img src={logo} alt=""/>
	      <span>Buydeal.EU</span>
	    </div>
	    <div className="nav-buttons">
	   <div className="nav-menu">
			<span className="nav-link" onClick={() => navigate("/orginfo")}>Event Organisers</span>
		</div>
		<div className="nav-menu">
			<span className="nav-link" onClick={() => navigate("/homepagehelp")}>Help</span>
		</div>		
	      <button
	        className="btn-primary"
	        onClick={() => navigate("/login")}>
	        Organiser Login
	      </button>
	    </div>
	  </div>
	</header>

      {/* Hero Section 
      <section className="eo-hero">
        <h1>Host & Manage Your Events Seamlessly</h1>
        <p>
          Everything you need to create, sell, manage, and analyze your events
          — all in one powerful platform.

		  Create, sell, and manage event tickets all in one place. Our Event Ticket Management System helps organizers create events quickly, sell tickets securely, and track performance in real time.

		  Whether you’re hosting a workshop, concert, or festival, we make ticketing simple, reliable, and scalable.

        </p>
        <button className="eo-primary-btn">Get Started</button>
      </section> */}
	  
	  <section className="main">
	  	<div className="main-text fade-up">
		  <h1>Simple & Transparent Ticketing System</h1>

		  <ul className="main-text-points">
		    <li>Built for small and mid-scale events</li>
		    <li>Simple, transparent, and fair transaction fee per ticket</li>
		    <li>No additional booking fees</li>
		  </ul>
		  
		  <p>
		  Create, Sell, and Manage event tickets all in one place. Our Event Ticket Management System helps organizers create events quickly, sell tickets securely, and track performance in real time.

		  Whether you’re hosting a workshop, concert, or festival, we make ticketing simple, reliable, and scalable.

		  </p>
		</div>


		<div className="main-image">
			<img src={event_img} alt=""></img>
		</div>	
	  </section>

      {/* Event Details */}
      <section className="main-text-detail">
        <h2>What You Can Do</h2>
        <div className="eo-grid">
          <div className="eo-card highlight">
            <h3>Create Events</h3>
            <p>
              Set up events hassle free in simple steps.
            </p>
          </div>

          <div className="eo-card highlight">
            <h3>Sell Tickets Online</h3>
            <p>
              Accept online payments, generate & share QR codes .
            </p>
          </div>

          <div className="eo-card highlight">
            <h3>Manage Attendees</h3>
            <p>
              View buyers, Verify tickets, & track sales.
            </p>
          </div>

          <div className="eo-card highlight">
            <h3>Analytics & Reports</h3>
            <p>
              Get insights on ticket sales & revenue.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="eo-section eo-pricing">
        <h2>Pricing Plans</h2>

        <div className="eo-grid">
          <div className="eo-price-card highlight">
            <h3>Free Events</h3>
            <p className="price">€0</p>
            <ul>
              <li>Free event creation</li>
			  <li>QR code for ticket</li>
			  <li>Sales analytics</li>
              <li>Email delivery</li>
            </ul>
          </div>

          <div className="eo-price-card highlight">
            <h3>Paid Events</h3>
            <p className="price">€ 0,25 / ticket</p>
            <ul>
              <li>Unlimited attendees</li>
              <li>Online payments</li>
              <li>Sales analytics</li>
              <li>Email Delivery</li>
            </ul>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="eo-cta">
        <h2>Are you interested ? </h2>
        <p>Send email to contact@buydeal.eu to start the process.</p>
      </section>
	  

	  <footer className="footer">
	  <div className="footer-bottom">
	    <span>© {new Date().getFullYear()} Buydeal.eu B.V. All Rights Reserved.</span>
	    <div className="footer-legal">
	      <a href="/privacy">Privacy Policy</a>
	      <a href="/toc">Terms &amp; Conditions (Buyers)</a>
	      <a href="/toc?tab=organisers">Terms &amp; Conditions (Organisers)</a>
	    </div>
	  </div>
	  </footer>

    </div>
  );
}


export default HomePageOrgInfo;